import { tossPaymentInit } from '../lib/data';
import { getTossInstallment, responseDataParse } from '../lib/toss';
import { useState } from 'react';
import { ITossPayment } from '../models/toss.model';
import { useTranslation } from 'react-i18next';

const useToss = () => {
  const { t } = useTranslation();

  const [data, setData] = useState<ITossPayment | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ITossPayment | string | undefined>(
    undefined,
  );

  const execute = (
    orderId: string,
    amount: number,
    installment: string,
    mid: string,
    vat: number,
    taxFreeAmount: number,
    orderName: string,
    studentName?: string,
  ) => {
    setData(undefined);
    setIsLoading(true);
    setError(undefined);
    let body = '';
    body += `VAN_TRANTYPE=${tossPaymentInit.VAN_TRANTYPE}&`;
    body += `LGD_TXNAME=${tossPaymentInit.LGD_TXNAME}&`;
    body += `LGD_REQTYPE=${tossPaymentInit.LGD_REQTYPE}&`;
    body += `LGD_PAYTYPE=${tossPaymentInit.LGD_PAYTYPE}&`;
    body += `LGD_TAXFREEAMOUNT=${taxFreeAmount}&`;
    body += `LGD_VAT=${vat}&`;
    body += `VAN_SFEEAMOUNT=${tossPaymentInit.VAN_SFEEAMOUNT}&`;
    body += `LGD_OID=${orderId}&`;
    body += `LGD_AMOUNT=${String(amount)}&`;
    body += `LGD_INSTALL=${getTossInstallment(installment)}&`;
    body += `LGD_MID=${mid}&`;
    body += `LGD_PRODUCTINFO=${orderName}&`;
    body += `LGD_BUYER=${studentName || ''}&`;

    const HttpRequest = new XMLHttpRequest();

    HttpRequest.onreadystatechange = () => {
      if (HttpRequest.readyState === 4) {
        try {
          const result = responseDataParse(HttpRequest.responseText);
          // console.log('tossResult: ', result);
          if (Object.keys(result).length === 0) {
            setError(t('common.error.3'));
          } else if (result.Respcode === '0000') {
            setData(result);
          } else {
            setError(result);
          }
        } catch (e) {
          setData(undefined);
          setError(t('common.error.4'));
        }
        setIsLoading(false);
      }
    };
    HttpRequest.open('POST', 'http://127.0.0.1:10002', true);
    HttpRequest.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded; charset=UTF-8',
    );
    HttpRequest.send(body);
  };

  return {
    data,
    isLoading,
    error,
    execute,
  };
};

export default useToss;
